







































































import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import {InvoiceLin,InvoiceLinLabels} from '../invoicing.vue'
@Component({
  components: {},
  data(){
    return {InvoiceLin, InvoiceLinLabels}
  }
})
export default class radio extends Vue {
  show = false;
  setShow(stat) {
    this.show = stat;
  }
  @Prop({
    type: Object,
    default: {},
  })
  public info: Object;
  sure(){
    this.$emit('submit')
  }
}
